var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.element)?_c('div',{staticClass:"l-learn-follow-read"},[(_vm.isVideoExplain)?_c('LLearnVideo',{ref:"LLearnVideo",staticClass:"follow-read-vedio",attrs:{"options":{
      vid: _vm.vid,
      autoplay: false,
      hidePlayBtn: true,
      canstop: false,
    }},on:{"play":_vm.onPlay,"leavingFull":_vm.leavingFull}}):_vm._e(),_c('div',{staticClass:"lSoundRecording-btn"},[_c('lRecorder',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 1),expression:"status === 1"}],ref:"recorder",attrs:{"options":_vm.recorderOptions,"btn-text":_vm.btnName},on:{"result":_vm.onresult,"start":_vm.onstart,"init":_vm.onRecordInit}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }